import { AttendanceStatus } from "@/api/reservation/dto";
import { useUpdateAttendanceStatus } from "@/api/reservation/useUpdateAttendanceStatus";
import { Box, Button, Group, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

interface AttendanceStatusSelectorProps {
  reservationId: number;
  currentStatus: "ON_TIME" | "LATE" | "NO_SHOW" | "CANCELLED" | null | undefined;
  isPast: boolean;
}

const borderBoxStyle = {
  border: "1px solid gray",
  borderRadius: "10px",
  padding: "5px",
};

export function AttendanceStatusSelector({
  reservationId,
  currentStatus,
  isPast,
}: AttendanceStatusSelectorProps) {
  const updateAttendanceStatusMutation = useUpdateAttendanceStatus();

  const handleOnTimeClick = () => {
    updateAttendanceStatusMutation.mutate({
      reservationId,
      data: { attendanceStatus: AttendanceStatus.ON_TIME },
    });
  };

  const handleLateClick = () => {
    updateAttendanceStatusMutation.mutate({
      reservationId,
      data: { attendanceStatus: AttendanceStatus.LATE },
    });
  };

  if (isPast) {
    return (
      <Box style={borderBoxStyle} p="md">
        <Text ta="center" c="dimmed" size="sm" mb="xs">
          참석 상태
        </Text>
        <Text ta="center" c="white" fw={700} size="lg">
          {currentStatus === "ON_TIME"
            ? "7시에 만나요 🥳"
            : currentStatus === "LATE"
              ? "조금 늦을거 같아요 😭"
              : "응답 없음"}
        </Text>
      </Box>
    );
  }

  return (
    <Group justify="space-evenly">
      <Button
        variant="outline"
        color="white"
        onClick={handleOnTimeClick}
        leftSection={currentStatus === "ON_TIME" ? <IconCheck size={16} /> : undefined}
        style={currentStatus === "ON_TIME" ? { borderColor: "#FFD700", borderWidth: 3 } : undefined}
      >
        7시에 만나요 🥳
      </Button>
      <Button
        variant="outline"
        color="white"
        onClick={handleLateClick}
        leftSection={currentStatus === "LATE" ? <IconCheck size={16} /> : undefined}
        style={currentStatus === "LATE" ? { borderColor: "#FFD700", borderWidth: 3 } : undefined}
      >
        조금 늦을거 같아요 😭
      </Button>
    </Group>
  );
}
